import React from 'react';
import { Popover, PopoverProps } from 'antd';

export type ThemeDropdownProps = PopoverProps;

const ThemeDropdown: React.FC<PopoverProps> = props => {
    const mergedProps: PopoverProps = {
        transitionName: 'ant-fade',//ant-slide-up
        ...props
    }

    return (
        <Popover {...mergedProps}/>
    )
};

export default ThemeDropdown;
